;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { CanaryClient } from '@qogita/deprecated-canary-client'
import { queryOptions } from '@tanstack/react-query'
import { getPrivateQueryKey } from 'src/deprecated/utils/queryKey'

export function getOfferQueries(canaryClient: CanaryClient) {
  const queries = {
    all: () => [...getPrivateQueryKey(), 'offers'] as const,
    detail: (offerQid: string) =>
      queryOptions({
        queryKey: [...queries.all(), offerQid],
        queryFn: () => canaryClient.getOffer(offerQid),
      }),
    info: () =>
      queryOptions({
        queryKey: [...queries.all(), 'info'],
        queryFn: () => canaryClient.getOffersInfo(),
      }),
    sellerBrands: () => {
      return queryOptions({
        queryKey: [...queries.all(), 'sellerBrands'],
        queryFn: () => canaryClient.getOffersSellerBrands(),
      })
    },
  }

  return queries
}
